export default "__VITE_ASSET__CEJkR7_C__"